"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFileSizeByMB = exports.MAX_POPULATION_SIZE = void 0;
exports.MAX_POPULATION_SIZE = 5;
function getFileSizeByMB(file) {
    return file.size / 1024 / 1024;
}
exports.getFileSizeByMB = getFileSizeByMB;
//# sourceMappingURL=FileUtils.js.map